import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["valueName", "childrenName", "noCheckboxName", "showSearch", "isOptionDisabled", "optionEcho", "onSearch", "optionRender", "dataRender"],
    _excluded2 = ["path"],
    _excluded3 = ["next"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { find, toObject } from '@jd/jmtd-tools/es/generator';
import { forOwn, mapValue } from '@jd/jmtd-tools/es/object';
import { getMaxLevel, iterate } from '@jd/jmtd-tools/es/tree';
import HighLight from '../HighLight';
import Label from '../Label';
import { getObjectValue } from './util';
export function getHeight(size) {
  var height = {
    large: 216,
    small: 180,
    mini: 180
  }[size] || 216;
  return height + 2;
}

function DefaultOptionRender(optionEcho, showSearch) {
  return showSearch ? function (item, searchText) {
    return /*#__PURE__*/React.createElement(Label, {
      theme: "light"
    }, /*#__PURE__*/React.createElement(HighLight, {
      keyword: searchText
    }, getObjectValue(item, optionEcho)));
  } : function (item) {
    return getObjectValue(item, optionEcho);
  };
}

export function BaseSelectRender(_ref, render) {
  var _ref$ExtraGenerator = _ref.ExtraGenerator,
      ExtraGenerator = _ref$ExtraGenerator === void 0 ? function () {
    return {};
  } : _ref$ExtraGenerator;
  return function (context, _ref2) {
    var _ref2$valueName = _ref2.valueName,
        valueName = _ref2$valueName === void 0 ? 'value' : _ref2$valueName,
        _ref2$childrenName = _ref2.childrenName,
        childrenName = _ref2$childrenName === void 0 ? 'children' : _ref2$childrenName,
        _ref2$noCheckboxName = _ref2.noCheckboxName,
        noCheckboxName = _ref2$noCheckboxName === void 0 ? 'noCheckbox' : _ref2$noCheckboxName,
        _ref2$showSearch = _ref2.showSearch,
        showSearch = _ref2$showSearch === void 0 ? false : _ref2$showSearch,
        _ref2$isOptionDisable = _ref2.isOptionDisabled,
        _isOptionDisabled = _ref2$isOptionDisable === void 0 ? function (item) {
      return item.disabled;
    } : _ref2$isOptionDisable,
        _ref2$optionEcho = _ref2.optionEcho,
        optionEcho = _ref2$optionEcho === void 0 ? function (item) {
      return item.label;
    } : _ref2$optionEcho,
        _ref2$onSearch = _ref2.onSearch,
        onSearch = _ref2$onSearch === void 0 ? function () {} : _ref2$onSearch,
        _ref2$optionRender = _ref2.optionRender,
        _optionRender = _ref2$optionRender === void 0 ? DefaultOptionRender(optionEcho, showSearch) : _ref2$optionRender,
        _ref2$dataRender = _ref2.dataRender,
        dataRender = _ref2$dataRender === void 0 ? function (x) {
      return x;
    } : _ref2$dataRender,
        otherProps = _objectWithoutProperties(_ref2, _excluded);

    var data = otherProps.data,
        searchLoading = otherProps.searchLoading,
        _otherProps$loading = otherProps.loading,
        loading = _otherProps$loading === void 0 ? searchLoading : _otherProps$loading,
        searchValue = otherProps.searchValue,
        searchData = otherProps.searchData;

    var props = _objectSpread({
      valueName: valueName,
      childrenName: childrenName,
      showSearch: showSearch,
      onSearch: onSearch,
      isOptionDisabled: function isOptionDisabled(item) {
        return _isOptionDisabled(item, context);
      },
      optionEcho: optionEcho,
      optionRender: function optionRender(item) {
        var arg1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : searchValue;

        var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref3$path = _ref3.path,
            path = _ref3$path === void 0 ? [item] : _ref3$path,
            other = _objectWithoutProperties(_ref3, _excluded2);

        return _optionRender(item, arg1, _objectSpread({
          path: path
        }, other), context);
      }
    }, otherProps);

    var options = dataRender(searchValue ? searchData !== null && searchData !== void 0 ? searchData : data : data);
    var extra = {
      options: options,
      searchProps: {
        empty: !(options !== null && options !== void 0 && options.length),
        showSearch: showSearch,
        searchLoading: loading,
        searchValue: searchValue,
        onSearch: onSearch
      },
      getValue: function getValue(item) {
        return getObjectValue(item, valueName);
      },
      getChildren: function getChildren(item) {
        return getObjectValue(item, childrenName);
      },
      getNoCheckbox: function getNoCheckbox(item) {
        return getObjectValue(item, noCheckboxName);
      }
    };

    var _ExtraGenerator = ExtraGenerator(context, props, extra),
        _ExtraGenerator$props = _ExtraGenerator.props,
        addedProps = _ExtraGenerator$props === void 0 ? {} : _ExtraGenerator$props,
        _ExtraGenerator$extra = _ExtraGenerator.extra,
        addedExtra = _ExtraGenerator$extra === void 0 ? {} : _ExtraGenerator$extra;

    return render(context, _objectSpread(_objectSpread({}, props), addedProps), _objectSpread(_objectSpread({}, extra), addedExtra));
  };
}
export var SelectRender = BaseSelectRender.bind(null, {
  ExtraGenerator: function ExtraGenerator(_, _ref4) {
    var searchValue = _ref4.searchValue,
        _optionRender2 = _ref4.optionRender,
        size = _ref4.size;
    return {
      props: {
        optionRender: function optionRender(item) {
          return _optionRender2(item, searchValue);
        }
      },
      extra: {
        dropdownHeight: getHeight(size)
      }
    };
  }
});
export var CascaderSelectRender = BaseSelectRender.bind(null, {
  ExtraGenerator: function ExtraGenerator(_, _ref5) {
    var data = _ref5.data,
        size = _ref5.size,
        childrenName = _ref5.childrenName,
        _ref5$isOptionUncheck = _ref5.isOptionUncheckable,
        isOptionUncheckable = _ref5$isOptionUncheck === void 0 ? function (item) {
      return item.uncheckable;
    } : _ref5$isOptionUncheck;
    var width = {
      large: 200,
      small: 180,
      mini: 180
    }[size] || 200;
    var maxLevel = getMaxLevel(data, {
      childrenName: childrenName
    });
    return {
      props: {
        isOptionUncheckable: isOptionUncheckable
      },
      extra: {
        maxDropdownWidth: width * maxLevel,
        maxLevel: maxLevel,
        dropdownListProps: {
          width: width,
          height: getHeight(size)
        }
      }
    };
  }
});

function updateCheckedTableKernel(data, isValueChecked, _ref6) {
  var _ref6$childrenName = _ref6.childrenName,
      childrenName = _ref6$childrenName === void 0 ? 'children' : _ref6$childrenName,
      _ref6$valueName = _ref6.valueName,
      valueName = _ref6$valueName === void 0 ? 'value' : _ref6$valueName,
      lastCancel = _ref6.cancel,
      lastSelect = _ref6.check,
      lastCancelAll = _ref6.cancelAll,
      lastSelectAll = _ref6.checkAll;
  var allCanceled = true;
  var allChecked = true;
  var maxLevel = 0;

  var getValue = function getValue(item) {
    return getObjectValue(item, valueName);
  };

  var next = {};
  var levelsSelected = {};
  var selectedTable = toObject(find(iterate(data, {
    childrenName: childrenName
  }), function (_ref7) {
    var node = _ref7.node;
    return isValueChecked(getValue(node));
  }), function (_ref8) {
    var node = _ref8.node,
        path = _ref8.path,
        level = _ref8.level;
    return [getValue(node), {
      node: node,
      children: getObjectValue(node, childrenName),
      path: path,
      level: level
    }];
  }); // 计算选中状态

  function getSelectState(list, level, parent, parentSelected, parentCanceled) {
    var listSelected = true; // 是否全选

    var listCanceled = true; // 是否全部取消

    var force = false;
    maxLevel = Math.max(maxLevel, level);

    var _iterator = _createForOfIteratorHelper(list),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var children = getObjectValue(item, childrenName);
        var value = getValue(item);
        var curSelectState = null; // 当前选中状态，null：未设置、0：取消、1：半选、2：选中

        var cancelThis = lastCancel === value; // 是否取消了当前选项

        var selectThis = lastSelect === value; // 是否选中了当前选项

        var path = parent.concat(item);

        if (cancelThis || parentCanceled || lastCancelAll) {
          // 如果取消了，或者父选项取消了，该选项取消
          curSelectState = 0;
        } else if (selectThis || parentSelected || selectedTable[value] || lastSelectAll) {
          // 如果选中了，或者父选项选中了，该选项选中
          curSelectState = 2;
        }

        if (children && children.length) {
          // 递归调用子选项
          // 如果自选项被强制更改，使用子选项的选中状态改变父选项的选中状态
          var _getSelectState = getSelectState(children, level + 1, path, curSelectState === 2, curSelectState === 0),
              _getSelectState2 = _slicedToArray(_getSelectState, 2),
              childrenForce = _getSelectState2[0],
              childrenSelectedState = _getSelectState2[1];

          if (curSelectState === null || childrenForce) {
            curSelectState = childrenSelectedState;
          }

          force = force || childrenForce;
        } // 根据当前选中状态计算父选中状态


        if (curSelectState === 2) {
          listCanceled = allCanceled = false;

          if (levelsSelected[level] !== false) {
            levelsSelected[level] = true;
          }

          selectedTable[value] = {
            node: item,
            level: level,
            path: path,
            children: children
          };
        } else if (curSelectState === 1) {
          listCanceled = listSelected = allChecked = false;
          delete selectedTable[value];
          levelsSelected[level] = false;
        } else {
          listSelected = allChecked = false;
          delete selectedTable[value];
        }

        next[value] = curSelectState; // 计算强制

        force = force || cancelThis || selectThis;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return [force, listSelected ? 2 : listCanceled ? 0 : 1];
  }

  getSelectState(data, 0, []);
  return {
    selectedTable: selectedTable,
    allCanceled: allCanceled,
    allChecked: allChecked,
    maxLevel: maxLevel,
    next: next,
    levelsSelected: levelsSelected
  };
}

export function updateCheckedTable(data, checkedTable) {
  var arg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var mapper = {
    2: true,
    1: 'indeterminate'
  };

  var _updateCheckedTableKe = updateCheckedTableKernel(data, function (v) {
    return checkedTable[v] === true;
  }, arg),
      next = _updateCheckedTableKe.next,
      other = _objectWithoutProperties(_updateCheckedTableKe, _excluded3);

  return _objectSpread({
    next: mapValue(next, function (v) {
      var _mapper$v;

      return (_mapper$v = mapper[v]) !== null && _mapper$v !== void 0 ? _mapper$v : false;
    })
  }, other);
}
export function cascaderMultiSelect(_ref9) {
  var data = _ref9.data,
      selected = _ref9.selected,
      lastCancel = _ref9.lastCancel,
      lastSelect = _ref9.lastSelect,
      lastSelectAll = _ref9.lastSelectAll,
      lastCancelAll = _ref9.lastCancelAll,
      _ref9$valueName = _ref9.valueName,
      valueName = _ref9$valueName === void 0 ? 'value' : _ref9$valueName,
      _ref9$childrenName = _ref9.childrenName,
      childrenName = _ref9$childrenName === void 0 ? 'children' : _ref9$childrenName,
      _ref9$minEchoLevel = _ref9.minEchoLevel,
      minEchoLevel = _ref9$minEchoLevel === void 0 ? null : _ref9$minEchoLevel,
      _ref9$isOptionDisable = _ref9.isOptionDisabled,
      isOptionDisabled = _ref9$isOptionDisable === void 0 ? function (item) {
    return item.disabled;
  } : _ref9$isOptionDisable;
  var selectedSet = new Set(selected);

  var _updateCheckedTableKe2 = updateCheckedTableKernel(data, function (v) {
    return selectedSet.has(v);
  }, {
    cancel: lastCancel,
    check: lastSelect,
    cancelAll: lastCancelAll,
    checkAll: lastSelectAll,
    valueName: valueName,
    childrenName: childrenName
  }),
      maxLevel = _updateCheckedTableKe2.maxLevel,
      allChecked = _updateCheckedTableKe2.allChecked,
      allCanceled = _updateCheckedTableKe2.allCanceled,
      stateTable = _updateCheckedTableKe2.next,
      levelsSelected = _updateCheckedTableKe2.levelsSelected,
      selectedTable = _updateCheckedTableKe2.selectedTable;

  var echoLevel = null; // 计算回显层级

  forOwn(levelsSelected, function (canEcho, level) {
    level = parseInt(level, 10); // 当层级中的每一项都可选时，该层级才可选

    var isLevelEnabled = Object.values(selectedTable).filter(function (_ref10) {
      var nodeLevel = _ref10.level;
      return nodeLevel === level;
    }).every(function (_ref11) {
      var node = _ref11.node;
      return !isOptionDisabled(node);
    });

    if (canEcho && isLevelEnabled && (echoLevel === null || level < echoLevel)) {
      echoLevel = level;
    }
  }); // 设置最小回显层级

  if (minEchoLevel != null) {
    echoLevel = Math.max(minEchoLevel, echoLevel);
  } // 计算回显


  var echoOptions = Object.values(selectedTable).filter(function (_ref12) {
    var level = _ref12.level,
        children = _ref12.children;
    return level === echoLevel || level < echoLevel && (!children || children.length === 0);
  }).map(function (i) {
    return i.node;
  });
  return {
    maxLevel: maxLevel,
    selectedTable: selectedTable,
    stateTable: stateTable,
    echoOptions: echoOptions,
    echoLevel: echoLevel,
    allChecked: allChecked,
    allCanceled: allCanceled
  };
}